import { HttpClient } from '@angular/common/http';
import { EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { Config } from '../../config/config';
import { SharedDataService } from '../../service/shared-data.service';
import { cloneDeep } from 'lodash';
import { element } from 'protractor';

@Component({
  selector: 'app-new-secondary-section-form',
  templateUrl: './new-secondary-section-form.component.html',
  styleUrls: ['./new-secondary-section-form.component.scss']
})
export class NewSecondarySectionFormComponent implements OnInit {

  addedSection: any;
  i: number;
  insideAddedSection: boolean = false;
  currentSelectedSection: number;
  sectionSuggestion: any;
  filteredNewSectionSuggestion: any =[];
  sectionQuery: any = '';
  subSectionQuery: string ='';
  insideAddedSubsection: boolean = false;
  currentSelection = 0;
  filteredNewSubsectionSuggestion: any =[];
  subsectionSuggestion: any = [];

  @ViewChild('sectionList', {static: false}) sectionList;
  @ViewChild('subSectionList', {static: false}) subSectionList;
  @ViewChildren('sectionInput') sectionField;
  @ViewChildren('subSectionInput') subSectionField;
  allSubSections: any;


  @Input()
  set index (input: number){
    this.i = input;
  }
  @Input()
  set sendAddedSection (addedSection: any) {
    this.addedSection = addedSection ? addedSection : [];
  }
  @Input()
  set sectionSuggestionList1 (sectionSuggestionList: any) {
    this.sectionSuggestion = sectionSuggestionList ? sectionSuggestionList : [];
  }
  @Input() listOfSecondarySections:any;

  @Input() subSectionName:any;

  @Input() sectionName:any;

  @Input()
  set listOfAllSubsections (subsectionList: any) {
    this.allSubSections = subsectionList ? cloneDeep(subsectionList) : [];
  }
  @Input() storyEditMode : boolean;

  @Output() sectionChanged: EventEmitter<number> = new EventEmitter();

  @Input() sectionSubsection : Map<String,Array<any>>;

  @Input() subSectionsId: any[];

  constructor(private config: Config,
    private http: HttpClient,
    private snotify: SnotifyService,
    private sharedService: SharedDataService) { }
  
    ngOnChanges(changes: SimpleChanges) {
    
  }

  ngOnInit() {
    this.subSectionsId.push(null);
    if(this.addedSection['section']){
      this.sectionQuery = this.addedSection['section'];
    }
    if(this.addedSection['subSection']){
      this.subSectionQuery = this.addedSection['subSection'];
    }
    if(this.addedSection['section'] != '')
    {
      let body = [];
              body.push(this.addedSection['section']);
              //need to check again for change data to data2
              this.http.put(this.config.get('product').baseUrl + '/api/cms/page/childPages?source=SECTION', body).subscribe((data2:[]) => {
                if (data2) {
                  this.subsectionSuggestion = data2;
                  if(this.addedSection['subSection'] != '')
                  {
                    this.subsectionSuggestion.forEach(element => {
                      if(element.key == this.addedSection['subSection'])
                      {
                        //this.subSectionsId.push(element.value);
                        this.subSectionsId[this.i] = element.value;
                      }
                    });
                  }
                }
              },(error)=>{
                this.subsectionSuggestion = [];
                // this.subSectionsId.push(null);
                this.snotify.error("Failed to fetch all subsections",'', this.sharedService.getConfig(false));
              });
    }else if(this.allSubSections && this.allSubSections.length>0){
      this.subsectionSuggestion = cloneDeep(this.allSubSections);
    }
  }

  focusInSuggest(model, index = 1) {
    if (model === 'section'){
        this.insideAddedSection = true;
        this.currentSelectedSection = index;
      // if (this.addedSection['section'] === null || this.addedSection['section'] === '') {
      //   this.filteredNewSectionSuggestion = this.sectionSuggestion;
      // }
      if (this.sectionQuery === '') {
        this.filteredNewSectionSuggestion = this.sectionSuggestion;
      } else if(this.sectionQuery){
        this.filteredNewSectionSuggestion = this.sectionSuggestion.filter(function (el) {
          return el.toLowerCase().indexOf(this.sectionQuery.toLowerCase()) > -1;
        }.bind(this));
      }
    }
    if (model === 'subSection') {
      this.insideAddedSubsection = true;
      this.currentSelectedSection = index;
      if (this.subSectionQuery === '') {
        if (this.addedSection['section'] !== null && this.addedSection['section'] !== '') {
          //this.filteredSubSectionSuggestion = this.subSectionSuggestion[this.storyData.metadata.section];
          // this.removeElements(this.subsectionSuggestion);
          this.filteredNewSubsectionSuggestion = this.subsectionSuggestion;
        } else {
          // this.removeElements(this.allSubSections);
          this.filteredNewSubsectionSuggestion = this.allSubSections;
        }
      } else if(this.subSectionQuery){
        // this.removeElements(this.subsectionSuggestion);
        this.filteredNewSubsectionSuggestion = this.subsectionSuggestion.filter(function (el) {
          return el['key'].toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
        }.bind(this));
      }
    }
  }
  filterAutoCompleteUp(event, model) {
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter' && event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      if (model === 'section' && event.keyCode !== 0) {
        // console.log('inside => ' + this.insideSection);
        if (this.insideAddedSection) {
          if (this.sectionQuery.length > 0) {
            this.filteredNewSectionSuggestion = this.sectionSuggestion.filter(function (el) {
              return el.toLowerCase().indexOf(this.sectionQuery.toLowerCase()) > -1;
            }.bind(this));
            // console.log('array => ' + this.filteredSectionSuggestion);
          } else {
            this.addedSection['section'] = '';
            this.addedSection['subSection'] = '';
            this.addedSection['subSectionId'] = null;
            this.subSectionsId[this.i] = null;
            this.filteredNewSectionSuggestion = this.sectionSuggestion;
            this.sectionChanged.emit(this.addedSection);
          }
        } else {
          this.insideAddedSection = true;
          this.filteredNewSectionSuggestion = [];
        }

      }
      else if (model === 'subSection') {
        if (this.insideAddedSubsection) {
          if (this.addedSection['section'] !== null && this.addedSection['section'].trim() !== '') {
            if (this.subSectionQuery.length > 0) {
              this.filteredNewSubsectionSuggestion = this.subsectionSuggestion.filter(function (el) {
                return el['key'].toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.addedSection['subSection'] = '';
              this.addedSection['subSectionId'] = null;
              this.subSectionsId[this.i] = null;
              this.filteredNewSubsectionSuggestion = this.subsectionSuggestion;
              this.sectionChanged.emit(this.addedSection);
            }
          } else {
            if (this.subSectionQuery.length > 0) {
              this.filteredNewSectionSuggestion = this.allSubSections.filter(function (el) {
                return el['key'].toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
              }.bind(this));
            } else {
              this.addedSection['subSection'] = '';
              this.addedSection['subSectionId'] = null;
              this.subSectionsId[this.i] = null;
              this.filteredNewSectionSuggestion = this.allSubSections;
              this.sectionChanged.emit(this.addedSection);
            }
          }
        } else {
          this.insideAddedSubsection = true;
          this.filteredNewSubsectionSuggestion = [];
        }
      }

    }
    // this.currentSelection = 0;
    return true;
  }

  filterAutoCompleteDown(event, model) {
    if (event.key === 'Enter') {
      if (model === 'section') {
        this.insideAddedSection = false;
        this.selectAutoComplete(model, this.filteredNewSectionSuggestion[this.currentSelection]);
      }
      if (model === 'subSection') {
        this.insideAddedSubsection = false;
        this.selectAutoComplete(model, this.filteredNewSubsectionSuggestion[this.currentSelection]);
      }
    }
    else if (event.keyCode === 40) {
      event.preventDefault();
      if (model === 'section') {
        if (this.currentSelection < (this.filteredNewSectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.sectionList.nativeElement.scrollBy(0, 23);
        }
      }
      if (model === 'subSection') {
        if (this.currentSelection < (this.filteredNewSubsectionSuggestion.length - 1)) {
          this.currentSelection += 1;
          this.subSectionList.nativeElement.scrollBy(0, 23);
        }
      }
      event.stopPropagation();
    }
    else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideAddedSection = false;
      this.insideAddedSubsection = false;
      event.stopPropagation();
    }
    else if (event.keyCode === 38) {
      event.preventDefault();
      if (this.currentSelection > 0) {
        this.currentSelection -= 1;
        if (model === 'section') {
          this.sectionList.nativeElement.scrollBy(0, -23);
        }
        if (model === 'subSection') {
          this.subSectionList.nativeElement.scrollBy(0, -23);
        }
      }
      event.stopPropagation();
    }
    else if (event.keyCode === 8) {
      if (model === 'section') {
        if(this.sectionSuggestion.indexOf(this.addedSection["section"])==-1)
        {
          this.sectionSuggestion.push(this.addedSection["section"]);
          this.addedSection["section"]="";
        }
      }
      // if(model ==='subSection') {
      //   if(this.subsectionSuggestion.indexOf(this.addedSection["subSection"])==-1)
      //   {
      //     this.subsectionSuggestion.push(this.addedSection["subSection"]);
      //     this.addedSection["subSection"]="";
      //   }
      // }
    }

    else {
      this.currentSelection = 0;
    }
    return true;
  }

  selectAutoComplete(model, item) {
    if (model === 'section') {
      this.sectionQuery = item;
      this.addedSection['section'] = item;
      if(this.sectionSuggestion.indexOf(item) < 0 || !this.checkForSuggestion(this.subsectionSuggestion,this.addedSection['subSection']))
      {
        this.addedSection['subSection'] = '';
        this.addedSection['subSectionId'] = null;
        this.subSectionsId[this.i] = null;
        this.subSectionQuery = '';
      }

      let body = [];
        body.push(item);
        this.http.put(this.config.get('product').baseUrl + '/api/cms/page/childPages?source=SECTION', body).subscribe((data:any[]) => {
          if (data && data.length>0) {
            //if(data.indexOf(this.addedSection['subSection']) < 0)
            if(!this.checkForSuggestion(data,this.addedSection['subSection']))
            {
              this.addedSection['subSection'] = '';
              this.addedSection['subSectionId'] = null;
              this.subSectionsId[this.i] = null;
              this.subSectionQuery = '';
            }
              this.subsectionSuggestion = cloneDeep(data);
          } else {
            this.addedSection['subSection'] = '';
            this.addedSection['subSectionId'] = null;
            this.subSectionsId[this.i] = null;
            this.subSectionQuery = '';
            this.subsectionSuggestion = [];
          }
          this.sectionChanged.emit(this.addedSection);
        },(error)=>{
            this.snotify.error("Failed to fetch all secondary subsections",'', this.sharedService.getConfig(false));
            this.sectionChanged.emit(this.addedSection);
        });
        this.filteredNewSectionSuggestion = [];
    }
    else if (model === 'subSection') {
      // this.subSectionQuery = item;
      // this.addedSection['subSection'] = item;
      this.subSectionQuery = item.key;
      this.addedSection['subSection'] = item.key;
      this.addedSection['subSectionId'] = item.value;
      this.subSectionsId[this.i] = item.value;
      if (this.addedSection['section'] === null || this.addedSection['section'] === '') {

        let body = +item.value;
            this.http.put(this.config.get('product').baseUrl + '/api/cms/page/parentPage?source=SUBSECTION', body).subscribe((data:any[]) => {
              if (data && data.length>0) {
                this.addedSection['section'] = data[0].key;
                this.sectionQuery = data[0].key;
                this.sectionChanged.emit(this.addedSection);
                let body2 = [];
                body2.push(data[0].key);
                this.http.put(this.config.get('product').baseUrl + '/api/cms/page/childPages?source=SECTION', body2).subscribe((data2: any[]) => {
                  if (data2 && data2.length > 0) {
                    this.subsectionSuggestion = cloneDeep(data2);
                  } else {
                    this.subsectionSuggestion = [];
                  }
                }, (error) => {
                  this.snotify.error("Failed to fetch all secondary subsections", '', this.sharedService.getConfig(false));
                });
    
              } 
            },(error)=>{
                this.snotify.error("Failed to fetch secondary section",'', this.sharedService.getConfig(false));
            });

      }else{
        this.sectionChanged.emit(this.addedSection);
      }
      this.filteredNewSubsectionSuggestion = [];
    }
    //this.sectionChanged.emit(this.addedSection)
  }

  checkForSuggestion(subSectionSuggestion, subSectionQuery)
  {
    if(subSectionSuggestion)
    {
      subSectionSuggestion.forEach((el)=>{
        if(subSectionQuery === el.key){
          return true;
        }
      })
    }
    return false;
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;

    if (this.sectionField['_results'][0] && clickedComponent === this.sectionField['_results'][0].nativeElement) {
      this.insideAddedSection = true;
      if (this.sectionQuery === '') {
        this.filteredNewSectionSuggestion = this.sectionSuggestion;
      }
      this.insideAddedSubsection = false;
      this.filteredNewSubsectionSuggestion = [];
    }
    else if (this.subSectionField['_results'][0] && clickedComponent === this.subSectionField['_results'][0].nativeElement) {
      this.insideAddedSubsection = true;
      if (this.subSectionQuery === '') {
        if (this.addedSection['section'] !== null && (this.addedSection['section']) !== '') {
          // this.removeElements(this.subsectionSuggestion);
          this.filteredNewSubsectionSuggestion = this.subsectionSuggestion;
        } else {
          // this.removeElements(this.allSubSections);
          this.filteredNewSubsectionSuggestion = this.allSubSections;
        }
      }else{
        // this.removeElements(this.subsectionSuggestion);
        this.filteredNewSubsectionSuggestion = this.subsectionSuggestion.filter(function (el) {
          return el['key'].toLowerCase().indexOf(this.subSectionQuery.toLowerCase()) > -1;
        }.bind(this));
      }
      this.insideAddedSection = false;
      this.filteredNewSectionSuggestion = [];
    }
    else {
      this.insideAddedSection = false;
      this.insideAddedSubsection = false;
      this.filteredNewSectionSuggestion = [];
      this.filteredNewSubsectionSuggestion = [];
    }
  }

  checkNoResult()
  {
    let elem = document.getElementById('subSectionFilter');
    if(elem && elem.getElementsByTagName('li') && elem.getElementsByTagName('li').length <= 0)
    {
      return true;
    }
    return false;
  }

}
